// ---------------------------------------------
// ---------------------------------------------
// -------------- Google Recapcha --------------
// ---------------------------------------------
// ---------------------------------------------
function setAttributGoogle() {
      document.querySelector(".g-recaptcha").setAttribute("data-sitekey", window.SitePreferences.CAPTCHAV2_API_KEY);
      // Create a new script element
      var scriptElement = document.createElement("script");
      // Set the src attribute
      scriptElement.src = "https://www.google.com/recaptcha/api.js";
      // Add async and defer attributes
      // scriptElement.async = true;
      // scriptElement.defer = true;
      // Append the script element to the document body (or head)
      document.querySelector("#popin-holder").appendChild(scriptElement);
}

function recapchaInit() {
      window.SitePreferences === undefined ? setTimeout(recapchaInit, 2000) : setAttributGoogle();
}

recapchaInit(); // Démarre la boucle

// ---------------------------------
// ---------------------------------
// ------------ Cookie -------------
// ---------------------------------
// ---------------------------------

// Select the element with the class 'bloc-popin'
var blocPopin = document.querySelector('.bloc-popin');

// Calculate the height of 1% of the viewport height and set it as a CSS variable
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// Update the CSS variable '--blocPopinHeight' on window resize
window.addEventListener('resize', () => {
      var blocPopinHeight = blocPopin.offsetHeight;
      document.documentElement.style.setProperty('--blocPopinHeight', `${blocPopinHeight}px`);
});

// Set the '--blocPopinHeight' CSS variable immediately
setTimeout(function () {
      var blocPopinHeight = blocPopin.offsetHeight;
      document.documentElement.style.setProperty('--blocPopinHeight', `${blocPopinHeight}px`);
}, 0);

// Add the class 'ready' to the blocPopin element after a delay of 600ms
setTimeout(function () {
      blocPopin.classList.add('ready');
}, 600);

// Check if a cookie named "sticky-bar-cookie" exists and hide the element with id 'popin-holder'
if (readCookie("sticky-bar-cookie")) {
      document.getElementById('popin-holder').style.display = 'none';
}

// Function to create a cookie with a given name, value, and expiration days
function createCookie(name, value, days) {
      if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (15 * 60 * 1000)); // 15 minutes expiration time
            var expires = "; expires=" + date.toGMTString();
      }
      else var expires = "";
      document.cookie = name + "=" + value + expires + "; path=/";
      document.getElementById('popin-holder').style.display = 'none';
}

// Function to read the value of a cookie with a given name
function readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
}

// Function to erase a cookie with a given name
function eraseCookie(name) {
      createCookie(name, "", -1);
}

// Function to hide an element with a given id
function hide(obj) {
      var el = document.getElementById(obj);
      el.style.display = 'none';
}

// ---------------------------------
// ---------------------------------
// ------------ Form -------------
// ---------------------------------
// ---------------------------------

// Select the element with the class 'bloc-popin'
let inputDiv = document.querySelector('.news-input .input');

// Select the element with the class 'bloc-popin'
let inputIcon = document.querySelector('.news-input .input-icon');

inputDiv.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
            sendInfoNewsletter();
      }
});

inputIcon.addEventListener('click', function (event) {
      sendInfoNewsletter();
});

function sendInfoNewsletter() {
      let formData = new FormData();

      formData.append("newsletter_email", inputDiv.value);

      formData.append("tokenCaptchaV2", grecaptcha.getResponse());

      fetch("/on/demandware.store/Sites-ETAM_FR-Site/fr_FR/Newsletter-Subscribe", {
            method: "POST",
            body: formData,
      }).then(response => response.json()).then(res => {
            console.log(res.success)
            if (res.success) {
                  document.querySelector(".form-response-popin").innerHTML = "Congratulations, you have successfully registered! You will receive an e-mail with your coupon code";
            } else {
                  document.querySelector(".form-response-popin").innerHTML = "Invalid email";
            }
      });

      console.log(formData);
}